module.exports = __webpack_public_path__ + "static/media/search.c628c284.svg";